/**
 * @flow weak
 */
import R from 'ramda';
import { createSelector, createStructuredSelector } from 'reselect';
import { getUser, getAmplitudeInstance } from '../session/getters';

// Raw Selectors - orders
export const yourOrder = (state) => state.yourOrder;
export const flash = (state) => state.myTickets.ui.flash;
export const ticket = (state) => state.yourOrder.ticket;
export const costItems = (state) => state.yourOrder.cost_items;

export const getCostItems = createSelector(
  [costItems, yourOrder],
  (costItems, yourOrder) => {
    if (!costItems) {
      return null;
    }

    return costItems.map((costItem) => {
      let priceLevel = null;

      if (costItem.price_level_id) {
        priceLevel = yourOrder.price_levels.find(priceLevel => costItem.price_level_id === priceLevel.id);
      }

      return {
        rate_id: costItem.rate_id,
        name: costItem.name,
        option_name: costItem.option_name,
        base_price: costItem.base_price,
        src_price: costItem.src_price,
        state: costItem.state,
        price_level: priceLevel,
        rate_type: costItem.rate_type
      };
    });
  }
);

export const getCostItemsUniqueIds = createSelector(
  getCostItems,
  (costItems) => {
    if (!costItems) {
      return null;
    }

    return R.uniq(costItems);
  }
);

export const getOrderWithCostItemQty = createSelector(
  [yourOrder, getCostItems, getCostItemsUniqueIds],
  (yourOrder, costItems, costItemsUniqueIds) => {
    if (!yourOrder || !costItems || !costItemsUniqueIds) {
      return null;
    }

    yourOrder.costItemsWithQty = costItemsUniqueIds.filter((costItem) =>
      costItem.state !== 'cancelled'
    ).map((ele, i, costItemsWithQty) => {
      costItemsWithQty[i].qty = costItems.filter((costItem) => {
        if (ele.price_level) {
          return costItem.price_level && ele.price_level.id === costItem.price_level.id;
        }
        else if (costItem.price_level) {
          return false;
        }
        return ele.rate_id === costItem.rate_id;
      }).length;
      costItemsWithQty[i].total = costItemsWithQty[i].qty * costItemsWithQty[i].base_price;
      costItemsWithQty[i].src_total = costItemsWithQty[i].qty * costItemsWithQty[i].src_price;
      return costItemsWithQty[i];
    });

    yourOrder.voidedCostItemsWithQty = costItemsUniqueIds.filter((costItem) =>
      costItem.state === 'cancelled'
    ).map((ele, i, voidedCostItemsWithQty) => {
      voidedCostItemsWithQty[i].qty = costItems.filter((costItem) => {
        if (ele.price_level) {
          return costItem.price_level && ele.price_level.id === costItem.price_level.id && costItem.state === 'cancelled';
        }
        else if (costItem.price_level) {
          return false;
        }
        return ele.rate_id === costItem.rate_id && costItem.state === 'cancelled';
      }).length;
      voidedCostItemsWithQty[i].total = voidedCostItemsWithQty[i].qty * voidedCostItemsWithQty[i].base_price;
      voidedCostItemsWithQty[i].src_total = voidedCostItemsWithQty[i].qty * voidedCostItemsWithQty[i].src_price;
      return voidedCostItemsWithQty[i];
    });

    return yourOrder;
  }
);

// connector
export default createStructuredSelector({
  yourOrder: getOrderWithCostItemQty,
  amplitudeInstance: getAmplitudeInstance,
  user: getUser,
  costItems,
  ticket,
  getCostItems,
  getCostItemsUniqueIds,
  flash
});



// WEBPACK FOOTER //
// ./src/modules/your-order/getters.js